// OK 06/11/2024

import styles from "./Menu.module.scss";
import { NavLink } from "react-router-dom";
import { useContext, useState } from "react";
import AlertContext from "../../context/AlertContext";

function Menu() {
  const [showLinks, setShowLinks] = useState(false);

  const {
    alertCarteCarbu,
    numberAlertCarteCarbu,
    alertVehCT,
    alertVehAss,
    numberAlertVehAss,
    numberAlertVehCT,
  } = useContext(AlertContext);

  const handleShowLinks = () => {
    setShowLinks(!showLinks);
  };

  return (
    <div
      className={`d-flex flex-column ${styles.containerMenu} ${
        showLinks ? styles.containerMenuNav : styles.containerMenuHide
      }`}
    >
      <button className={` ${styles.navbar_burger}`} onClick={handleShowLinks}>
        <span className={` ${styles.burger_bar}`}></span>
        {alertCarteCarbu && <span className={styles.alertBadge}></span>}
      </button>
      <NavLink
        to="/"
        className={` d-flex flex-row ${styles.navLinkStyle} ${styles.slideInDown1}`}
      >
        <button className={` ${styles.button}`} onClick={handleShowLinks}>
          <i className="fa-solid fa-house"></i>
          Home
        </button>
      </NavLink>
      <NavLink
        to="constructionSite"
        className={` d-flex flex-row ${styles.navLinkStyle} ${styles.slideInDown2}`}
      >
        <button className={` ${styles.button}`} onClick={handleShowLinks}>
          <i className="fa-solid fa-helmet-safety"></i>
          Chantiers
        </button>
      </NavLink>
      <NavLink
        to="customers"
        className={` d-flex flex-row ${styles.navLinkStyle} ${styles.slideInDown3}`}
      >
        <button className={` ${styles.button}`} onClick={handleShowLinks}>
          <i className="fa-solid fa-helmet-safety"></i>
          Clients
        </button>
      </NavLink>
      <NavLink
        to="/staff"
        className={` d-flex flex-row ${styles.navLinkStyle} ${styles.slideInDown4}`}
      >
        <button className={` ${styles.button}`} onClick={handleShowLinks}>
          <i className="fa-solid fa-person"></i>
          Personnels
        </button>
      </NavLink>
      <NavLink
        to="/invoice"
        className={` d-flex flex-row ${styles.navLinkStyle} ${styles.slideInDown5}`}
      >
        <button className={` ${styles.button}`} onClick={handleShowLinks}>
          <i className="fa-solid fa-file-invoice-dollar"></i>
          Facturation
        </button>
      </NavLink>
      <NavLink
        to="/material"
        className={` d-flex flex-row ${styles.navLinkStyle} ${styles.slideInDown6}`}
      >
        <button className={` ${styles.button}`} onClick={handleShowLinks}>
          <i className="fa-solid fa-hammer"></i>
          Materiels
        </button>
      </NavLink>
      <NavLink
        to="/product"
        className={` d-flex flex-row ${styles.navLinkStyle} ${styles.slideInDown7}`}
      >
        <button className={` ${styles.button}`} onClick={handleShowLinks}>
          <i className="fa-regular fa-money-bill-1"></i>
          Produits
        </button>
      </NavLink>
      <NavLink
        to="/vehicle"
        className={` d-flex flex-row ${styles.navLinkStyle} ${styles.slideInDown8}`}
      >
        <button className={` ${styles.button}`} onClick={handleShowLinks}>
          <i className="fa-solid fa-van-shuttle"></i>
          Vehicules
          {alertVehAss || alertVehCT ? (
            <span className={styles.numberBadge}>
              {numberAlertVehCT.length + numberAlertVehAss.length}
            </span>
          ) : (
            ""
          )}
        </button>
      </NavLink>
      <NavLink
        to="/fuelCard"
        className={` d-flex flex-row ${styles.navLinkStyle} ${styles.slideInDown9}`}
      >
        <button className={` ${styles.button}`} onClick={handleShowLinks}>
          <i className="fa-solid fa-gas-pump"></i>
          Carte carburants
          {alertCarteCarbu && (
            <span className={styles.numberBadge}>
              {numberAlertCarteCarbu.length}
            </span>
          )}
        </button>
      </NavLink>
      <NavLink
        to="/lodgement"
        className={` d-flex flex-row ${styles.navLinkStyle} ${styles.slideInDown10}`}
      >
        <button className={` ${styles.button}`} onClick={handleShowLinks}>
          <i className="fa-solid fa-house-user"></i>
          Logements
        </button>
      </NavLink>
      <NavLink
        to="/prestation"
        className={` d-flex flex-row ${styles.navLinkStyle} ${styles.slideInDown11}`}
      >
        <button className={` ${styles.button}`} onClick={handleShowLinks}>
          <i className="fa-solid fa-clock"></i>
          Prestations
        </button>
      </NavLink>
      <NavLink
        to="planning"
        className={` d-flex flex-row ${styles.navLinkStyle} ${styles.slideInDown12}`}
      >
        <button className={` ${styles.button}`} onClick={handleShowLinks}>
          <i className="fa-regular fa-calendar-days"></i>
          Plannings
        </button>
      </NavLink>
    </div>
  );
}

export default Menu;
